import { render, staticRenderFns } from "./VacationRolesModal.vue?vue&type=template&id=645a510a&"
import script from "./VacationRolesModal.vue?vue&type=script&lang=js&"
export * from "./VacationRolesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports